var React = require('react');

function IcFlagFr (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ic--flag--fr"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"ic--flag--fr"},[React.createElement("polygon",{"id":"Path","fill":"#3737D6","points":"-4.02455846e-15 0 8 0 8 16 -4.02455846e-15 16","key":0}),React.createElement("rect",{"id":"Rectangle","fill":"#FFFFFF","x":"8","y":"0","width":"8","height":"16","key":1}),React.createElement("polygon",{"id":"Path","fill":"#E61919","points":"16 0 24 0 24 16 16 16","key":2})]))]);
}

IcFlagFr.defaultProps = {"width":"24px","height":"16px","viewBox":"0 0 24 16","version":"1.1"};

module.exports = IcFlagFr;

IcFlagFr.default = IcFlagFr;
